
/* eslint-disable */
import axios from '../../../axios'
import store from '../../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init() {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const {config, response} = error
      const originalRequest = config

      // if (response && response.status === 401) {
      //   return Promise.reject({message: response.data.error})
      // }
        
      // Se conservan `response` y `status`: sustituir el error por solo `{message}`
      // dejaba muerta cualquier rama que mire el código HTTP (un 404 o un 409 esperados).
      return Promise.reject({
        message: (response && response.data && response.data.error) || error.message,
        response,
        status: response && response.status
      })
    })
  },

  loginQRFirstStep(email, pwd) { 
    return axios.post(process.env.VUE_APP_GO_API + '/auth/loginV3', {
      email,
      password: pwd
    })
  },

  loginQRSecondStep(apicode, code, userId, email) { 
    return axios.post(process.env.VUE_APP_GO_API + '/auth/login-secondV3', {
      apiCode: apicode,
      code: code,
      userId: userId,
      email: email
    })
  },

  // SSO genérico: canjea el ticket de un solo uso contra el endpoint PÚBLICO de
  // go-arpa. withCredentials (axios global) → go-arpa deja la cookie access_token,
  // igual que el login. Devuelve {token,userId,name} en el body (no se usa aquí: la
  // sesión va por cookie).
  ssoExchange(ticket) {
    return axios.post(process.env.VUE_APP_GO_API + '/sso/exchange', {
      ticket
    })
  },

  // Perfil del usuario de la sesión actual (cookie). Mismo userData que el login.
  me() {
    return axios.get(process.env.VUE_APP_GO_API + '/auth/me')
  },

  loginQRTemporalAccess(userId, token) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_GO_API + `/auth/temporal-token/emit-access/${token}/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  accessToken(apiCode) {
    return axios.post(process.env.VUE_APP_GO_API + "/auth/authorize", {
      apiCode
    })
      // return axios.post(process.env.VUE_APP_BROKER_API + "/accesstoken", {
      //   apiCode
      // })
  },
  // OK - being used
  refreshToken() { 
    return axios.post(process.env.VUE_APP_GO_API + '/tokens/refresh') // Quitado el return de tokens. Se setean AUTO 
    // return axios.post(process.env.VUE_APP_GO_API + '/tokens/refresh', {accessToken: localStorage.getItem('accessToken'), refreshToken: localStorage.getItem('refreshToken')})
  },

  logout() { 
    
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_GO_API + '/auth/logout')
        .then((response) => {
          // delete axios.defaults.headers.common["Authorization"]; // NECESARIO? 
          // delete axios.defaults.headers.common["access_token"];
          localStorage.clear()

        })
        .catch((error) => { reject(error) })

        // localStorage.removeItem('accessToken')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('loggedIn')
        localStorage.clear()

        resolve(true)
    })
   
  },
  getUserPermissions(id) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_GO_API + '/users/permissions/'+ id)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  deleteLocalUser() { 
      // localStorage.removeItem('accessToken')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('loggedIn')
      localStorage.clear()
  }
}
